import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  urlEnviroment = '';
  urlEnviromentIntegration : string = '';

  public URLactual = window.location.href;
  private httpClient: HttpClient;

  constructor(private handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
    this.assingEnviroments()
  }

  static ConfiSettings: any;

  assingEnviroments() {

    const listEnviromentsHealthbook = {
      dev: environment.apiEndPointDev,
      test: environment.apiEndPointTest,
      demo: environment.apiEndPointDemo,
      prod: environment.apiEndPointProd,
    };

    const listEnviromentIntegration = {
      dev: environment.apiIntegrationsDev,
      test: environment.apiIntegrationsTest,
      demo: environment.apiIntegrationsDemo,
      prod: environment.apiIntegrationsProd,
    };




    // Diccionario: URL -> entorno
    const urlMap: { [key: string]: keyof typeof listEnviromentsHealthbook } = {
      //Dev urls
      'https://agendamiento-frontend-c-desarrollo-gjgvdsg8b0a3htc3.eastus2-01.azurewebsites.net': 'dev',
      'localhost': 'dev',
      //Test urls
      'https://agendamiento-frontend-c-pruebas-ehe5c9fyb7gwehed.eastus2-01.azurewebsites.net': 'test',
      //Demo urls
      'https://agenda-demo-colcan.ithealth.co': 'demo',
      'https://agendamiento-frontend-c-demo-fmfqb3apb8egfnb5.eastus2-01.azurewebsites.net': 'demo',
      //Prod urls
      'https://agenda-colcan.ithealth.co': 'prod'
    };

    const matchKey = Object.keys(urlMap).find(url =>
      this.URLactual.includes(url)
    );

    const envName = matchKey ? urlMap[matchKey] : 'dev';
    this.urlEnviroment = listEnviromentsHealthbook[envName];
    this.urlEnviromentIntegration = listEnviromentIntegration[envName];

  }}
